module.exports = __webpack_public_path__ + "static/media/verify-email.1163523e.png";